<template>
    <main id="teinte">
        <section id="teinteDesktop">
            <div class="rel addToBasket">
                <h3 class="bold shippingDetail">{{ $t("basket.deliveryDetails") }}</h3>
                <div class="inputAddBasket" v-if="action ? action.action !== 'addPlanoToBasket' : true">
                    <span class="label">QTY</span><input type="text" class="inputQuantity" v-model="quantity" />
                    <span v-show="showUnit" class="units">{{ $t("basket.perPlano") }}</span>
                    <div class="msgError" v-if="quantity < 1">* valeur minimale 1</div>
                </div>

                <div v-show="showUnit" class="per inputAddBasket">
                    <span class="label">X</span><input type="text" class="inputQuantity" v-model="multiple" />
                    <span class="units">{{ $t("basket.units") }}</span>
                    <div class="msgError" v-if="multiple < 1">* valeur minimale 1</div>
                </div>
                <div class="basketBtnAdd">
                    <button class="btnExp basketButton" @click="createBasket();">{{ $t("basket.add") }}</button>
                </div>
                <CreateBasket v-if="openCreateBasket"></CreateBasket>
            </div>
        </section>
    </main>
</template>

<script>
import CreateBasket from "./CreateBasket";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        CreateBasket
    },
    data() {
        return {
            openCreateBasket: false,
            quantity: 1,
            multiple: 1,
            itemIntoBasket: {},
            showUnit: false
        };
    },
    props: ["action"],
    watch: {},
    methods: {
        ...mapActions("ordersStore", {
            setBasketItem: "setBasketItem"
        }),
        modalClose(close) {
            this.openCreateBasket = close;
        },
        close() {
            this.$emit("hideBasketModal");
        },
        createBasket() {
            if (this.quantity === "0" || this.multiple === "0") {
                this.$swal({
                    text: this.$t("messageError.addQuantityMultiple"),
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "red",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(result => {
                    this.quantity = "1";
                    this.multiple = "1";
                });
            } else {
                if (this.action && this.action.action === "addPlanoToBasket") {
                    this.itemIntoBasket = {
                        nbPlano: this.multiple,
                        plano: {
                            id: this.action.idPlano
                        }
                    };
                } else {
                    this.itemIntoBasket = {
                        quantity: this.quantity,
                        nbPlano: this.multiple,
                        component: {
                            id: this.$route.params.id ? this.$route.params.id : this.getBasketItemComponent.id
                        }
                    };
                }
                this.setBasketItem(this.itemIntoBasket);
                this.openCreateBasket = true;
            }
        }
    },
    computed: {
        ...mapGetters({
            getBasketItemComponent: "ordersStore/getBasketItemComponent"
        })
    },
    created() {}
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/themes";
.shippingDetail {
    margin-top: 0;
}
.addToBasket {
    @extend %second-background;
    @extend %primary-text;
    padding: 20px;
}
.quantity {
    padding-right: 5px;
}
.inputQuantity {
    width: 50px;
}
.units {
    font-size: 10px;
    padding-left: 7px;
}
.per {
}
.basketBtnAdd {
    display: inline-block;
}
.newBasketButton {
    bottom: 0;
    margin-bottom: 10px;
    margin-left: 20px;
}
.inputAddBasket {
    margin-bottom: 25px;
    .msgError {
        margin: 5px 0;
        color: red;
    }
    .label {
        width: 45px;
        display: inline-block;
        font-weight: normal;
        font-size: 13px;
        font-family: "oswald-regular", sans-serif;
    }
}
</style>



// WEBPACK FOOTER //
// AddToBasket.vue?effa667a